import { create } from 'zustand';

/** UI-состояние, которое не является серверными данными (те живут в React Query). */
interface UiState {
  reducedMotion: boolean;
  setReducedMotion: (v: boolean) => void;
  toast: { text: string; error: boolean } | null;
  showToast: (text: string, error?: boolean) => void;
  hideToast: () => void;
}

export const useUi = create<UiState>((set) => ({
  reducedMotion: localStorage.getItem('tarot.reduced') === '1',
  setReducedMotion: (v) => { localStorage.setItem('tarot.reduced', v ? '1' : '0'); set({ reducedMotion: v }); },
  toast: null,
  showToast: (text, error = false) => set({ toast: { text, error } }),
  hideToast: () => set({ toast: null }),
}));
